;(function ($) {

    $(document).ready(function(){

        window.dataLayer = window.dataLayer || [];


        $('#back-top-event').click(function(e){
            e.preventDefault();
            var eventtop = $('#featured-event-submenu').offset().top;
            $('html, body').animate({scrollTop:eventtop}, 500, 'easeInSine');
        });

        $('#discovery-next').on('click', function(e) {
            e.preventDefault();
            if(validateInputs()) {
                $('#error').hide();
                var step = parseInt($('.discovery-step.current').attr('data-step'));

                window.dataLayer.push({
                    'event':'completedBeerDiscoveryStep',
                    'eventCategory': 'Beer Discovery',
                    'eventAction': 'Completed Step',
                    'eventLabel': 'Step ' + step
                });

                var next = step + 1;
                $('.discovery-nav .step-' + step).removeClass('active');
                $('.btn-nav .active-number').text('0' + next);
                $('#step-'+step).removeClass('current').hide();
                $('.discovery-nav .step-' + next).addClass('active');
                $('#step-'+next).addClass('current').fadeIn();
                $('#beer-discovery').animate({ scrollTop: 'fast' });
                if(next == 3) {
                    $('#discovery-next').hide();
                    $('#discovery-submit').show();
                }
            } else {
                $('#error').fadeIn();
            }

        });

        $('#retake').on('click', function(e) {
            e.preventDefault();
            resetForm();

            window.dataLayer.push({
                'event':'resetBeerDiscoveryForm',
                'eventCategory': 'Beer Discovery',
                'eventAction': 'Retake'
            });

        });

        $('#discovery-submit').on('click', function(e) {
            if(validateInputs()) {
                //var inputs = $('#discovery-form').serialize();
                fetchBeer();
                $('#error').hide();
                $('.discovery-nav').hide();
                $('#step-3').hide();
                $('.btn-nav').hide();
                $('#results').fadeIn();
                $('#beer-discovery').animate({ scrollTop: 'fast' });
            } else {
                $('#error').fadeIn();
            }
        });

        $('.discover').click(function(e){
            e.preventDefault();
            $('#discovery-overlay').css('visibility', 'visible');
        });

        $('#beer-discovery .close, #discovery-exit').on('click', function(e) {
            e.preventDefault();
            $('#discovery-overlay').css('visibility', 'hidden');
            resetForm();
        });

        $('#open-discovery, .open-discovery').on('click', function(e) {
            e.preventDefault();
            $('#discovery-overlay').css('visibility', 'visible');
        });

        $( '#slider-range' ).slider({
            range: true,
            min: 1,
            max: 18,
            values: [ 5, 9 ],
            slide: function( event, ui ) {
                //console.log({ui})
                var delay = function() {

                    var handleIndex = ui.handleIndex;
                    var label = handleIndex == 0 ? '#min' : '#max';
                    $(label).html(ui.value + '%').position({
                        my: 'center top',
                        at: 'center top-30',
                        of: ui.handle,
                        offset: '0, 10'
                    });
                    $('#bottom-range').val($('#slider-range').slider('values', 0));
                    $('#top-range').val($('#slider-range').slider('values', 1));
                };

                // wait for the ui.handle to set its position
                setTimeout(delay, 5);
            }
        });

        $('#min').html($('#slider-range').slider('values', 0) + '%').position({
            my: 'center top',
            at: 'center top-30',
            of: $('#slider-range span:eq(0)'),
            offset: '0, 10'
        });

        $('#max').html($('#slider-range').slider('values', 1) + '%').position({
            my: 'center top',
            at: 'center top-30',
            of: $('#slider-range span:eq(1)'),
            offset: '0, 10'
        });

        $('.search-click').click(function(e){
            e.preventDefault();
            $('#search-page').submit();
        });

        $('.close-search').click(function(e){
            $('.search-modal').fadeOut();
        });

        if ($(window).width() < 1025) {
            $('.footer-nav-mobile .finder').click(function(e){
                e.preventDefault();
                if ( document.getElementById('location-beer-finder') ) {
                    var pagemap = $('#location-beer-finder').offset().top;
                    $('html, body').animate({scrollTop:pagemap}, 500, 'easeInSine');
                } else {
                    var page = window.location.pathname;
                    if(page == '/'){ //if homepage
                        //var homemap = $('.frontpage-beer-finder').offset().top;
                        //$('html, body').animate({scrollTop:homemap}, 500, 'easeInSine');
                        window.location.href = location.origin+"/beer-finder";
                    } else if (window.location.href.indexOf("/beer-finder") > -1) { //if beer finder page
                        var pagemap = $('.page-beer-finder').offset().top;
                        $('html, body').animate({scrollTop:pagemap}, 500, 'easeInSine');
                    } else if (window.location.href.indexOf("/beer/") > -1) { //if beer detail page
                        var beermap = $('.beer-details').offset().top;
                        $('html, body').animate({scrollTop:beermap}, 500, 'easeInSine');
                        $('.beer-details').slick('slickPrev');
                    } else { //any other page
                        //$('.beer-finder-modal').toggle();
                        //window.map = map;
                        //map.resize();
                        window.location.href = location.origin+"/beer-finder";
                    }
                }
            });
        }

        // $('#close-beer-filter-mobile').click(function(e){
        //     e.preventDefault();
        //     $('.beer-finder-modal').fadeOut();
        // });

        $('#open-beer-finder').click(function(e){
            $('#discovery-overlay').css('visibility', 'hidden');
            resetForm();
            e.preventDefault();
            if ( document.getElementById('location-beer-finder') ) {
                var pagemap = $('#location-beer-finder').offset().top;
                $('html, body').animate({scrollTop:pagemap}, 500, 'easeInSine');
            } else {
                var page = window.location.pathname;
                if(page == '/'){ //if homepage
                    // if ($('.frontpage-beer-finder').length > 0) {
                    //     var homemap = $('.frontpage-beer-finder').offset().top;
                    //     $('html, body').animate({ scrollTop: homemap }, 500, 'easeInSine');
                    // } else {
                    //     $('.beer-finder-modal').fadeIn();
                    //     window.map = map;
                    //     map.resize();
                    // }
                    window.location.href = location.origin+"/beer-finder";
                } else if (window.location.href.indexOf("/beer-finder") > -1) { //if beer finder page
                    var pagemap = $('.page-beer-finder').offset().top;
                    $('html, body').animate({scrollTop:pagemap}, 500, 'easeInSine');
                } else if (window.location.href.indexOf("/beer/") > -1) { //if beer detail page
                    var beermap = $('.beer-details').offset().top;
                    $('html, body').animate({scrollTop:beermap}, 500, 'easeInSine');
                    $('.beer-details').slick('slickPrev');
                } else { //any other page
                    window.location.href = location.origin+"/beer-finder";
                }
            }
        });

        $('.beer-finder-modal #close-beer-finder').click(function(e){
            e.preventDefault();
            $('.beer-finder-modal').fadeOut();
        });

        $('.close-cta').click(function(e){
            $('.cta-bar-wrapper').fadeOut();
        });



        // Add smooth scrolling for sections
        $('.one-event-link').on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 200
                }, 600, function(){
                    window.location.hash = hash;
                });
            }
        });

        eventSubMenu();
        
        $('.page-template-beer-discovery .custom-links .discovery-link').addClass('current');
    });

    //functions
    function resetForm() {
        $('#discovery-next').show();
        $('#discovery-submit').hide();
        $('#results').hide();
        $('.btn-nav').show();
        $('#step-1').fadeIn().addClass('current');
        $('.btn-nav .active-number').text('01');
        $('#discovery-form').trigger('reset');
    }

    function validateInputs() {
        if($('#step-1').hasClass('current')) {
            var checkboxes = $('.srm-picker input[type="checkbox"]');
        } else if($('#step-2').hasClass('current')) {
            var checkboxes = $('.hoppy input[type="radio"]');
        } else if($('#step-3').hasClass('current')) {
            var checkboxes = $('.discovery-flavors input[type="checkbox"]');
        }
        if(!checkboxes.is(':checked')) {
            return false;
        } else {
            return true;
        }
    }

    function displayResults(results) {
        // make sure the first beer displayed is from OB
        if(results[0].beer.brewery.id !== '5c48e2ed3596af000417e100') {
            var found = results.findIndex(function(elem) {
                return elem.beer.brewery.id == '5c48e2ed3596af000417e100';
            })
            //swap the first OB beer with the first item in the array
            var temp = results[found];
            results[found] = results[0];
            results[0] = temp;
        }
        var i;
        for (i = 0; i < results.length; i++) {
            console.log(results[i]);
            var div = $('#results .match-' + i);
            if(div.length > 0) {
                div.find('.name').text(results[i].beer.name);
                div.find('.description').text(results[i].beer.descriptionShort);
                div.find('.git-details').attr({
                    'href':results[i].beer.href,
                    'data-beer-name':results[i].beer.name,
                    'data-position':'position ' + position
                });
                div.find('#goto-beer-finder').attr({
                    'href':results[i].beer.href+'#slide-beer',
                    'data-beer-name':results[i].beer.name,
                    'data-position':'position ' + position
                });
                div.find('img').attr('src', 'https://s3-us-west-1.amazonaws.com/blkdg-canagement/uploads/' + results[i].beer.packageArt);
            }
        }
    }

    function handleUrlsPoorly(results) {
        return results.forEach(beer => {
            if (beer.beer.brewery.id === "5c48e2ed3596af000417e100") { //Oskar Blues
                beer.beer.breweryUrl = 'https://www.oskarblues.com/'
            } else if (beer.beer.brewery.id === "5c48f802b1c59900046674c1") { //Cigar City
                beer.beer.breweryUrl = 'https://www.cigarcitybrewing.com/'
            } else if (beer.beer.brewery.id === "5cca092ca4d31151965e77fb") { //Perrin
                beer.beer.breweryUrl = 'https://perrinbrewing.com'
            } else if (beer.beer.brewery.id === "5db883219d07d20520639ca8") { //Wasatch
                beer.beer.breweryUrl = 'https://www.wasatchbeers.com/'
            }
        })
    }

    function displayResultsNEW(results) {
        results.forEach(beer => {
            if (beer.beer.brewery.id === "5c48e2ed3596af000417e100") { //Oskar Blues
                beer.beer.breweryUrl = 'https://www.oskarblues.com/'
            } else if (beer.beer.brewery.id === "5c48f802b1c59900046674c1") { //Cigar City
                beer.beer.breweryUrl = 'https://www.cigarcitybrewing.com/'
            } else if (beer.beer.brewery.id === "5cca092ca4d31151965e77fb") { //Perrin
                beer.beer.breweryUrl = 'https://perrinbrewing.com'
            } else if (beer.beer.brewery.id === "5db883219d07d20520639ca8") { //Wasatch
                beer.beer.breweryUrl = 'https://www.wasatchbeers.com/'
            }
        })
        var i;
        for (i = 0; i < results.length; i++) {
            var div = $('#results .match-' + i);
            if (results[i].beer.packageArt === undefined) {
                var image = "/wp-content/themes/canarchy2.0/assets/images/beer-finder/placeholderCan.png"
            } else {
                var image = 'https://s3-us-west-1.amazonaws.com/blkdg-canagement/uploads/' + results[i].beer.packageArt
            }
            if(div.length > 0) {
                var position = i+1;
                div.find('.name').text(results[i].beer.name);
                div.find('.description').text(results[i].beer.descriptionShort);
                // div.find('.git-details').attr('href', results[i].beer.breweryUrl);
                div.find('.git-details').attr({
                    'href':results[i].beer.breweryUrl,
                    'data-beer-name':results[i].beer.name,
                    'data-position':'position ' + position
                });
                div.find('#goto-beer-finder').attr({
                    'href':results[i].beer.breweryUrl+'#slide-beer',
                    'data-beer-name':results[i].beer.name,
                    'data-position':'position ' + position
                });
                // div.find('#goto-beer-finder').attr('href', results[i].beer.href+'#slide-beer');
                div.find('img').attr('src', image);
            }
        }
    }

    function fetchBeer() {
        $.ajax({
            type: 'POST',
            dataType: "json",
            url: '/wp-admin/admin-ajax.php',
            data: {
                "action": "get_api_beers"
            },
            beforeSend: function() {
                $('#beerDiscoveryLoader').show();
            },
            success: function(response) {
                var data = $.parseJSON(response);
                var results = discoverBeer(data);
// console.log(results);
                displayResultsNEW(results);
                $('#beerDiscoveryLoader').hide();
            },
            error: function(err) {
                console.error(err);
            }
        });
    }

    // function getLinks(results, breweries) {
    //     console.log('results', results);
    //     console.log('breweries', breweries);

    //     //window.breweries = breweries;
    //     var beers = [];
    //     results.forEach(function (result) {
    //         //console.log({ result })
    //         var breweryID = result.beer.brewery.id;
    //         var beerID = result.beer._id
    //         var website = '';

    //         if (breweryID === '5c48e2ed3596af000417e100') { // OB
    //             //get the post link
    //             var found = vars.beers.findIndex(function(elem) {
    //                 return elem.id == beerID
    //             })
    //             if(found != -1) {
    //                 website = vars.beers[found].permalink
    //             } else {
    //                 website = 'https://oskarblues.com';
    //             }
    //             beers.push(result)

    //         } else if (breweryID === '5cca092ca4d31151965e77fb') { // perrin
    //             var found = vars.beers.findIndex(function(elem) {
    //                 return elem.id == beerID
    //             })
    //             if(found != -1) {
    //                 website = vars.beers[found].permalink
    //             } else {
    //                 website = 'https://perrinbrewing.com';
    //             }
    //             beers.push(result)
    //         } else {
    //             breweries.breweries.forEach(function(brewery) {
    //                 if(brewery._id == breweryID) {
    //                     website = brewery.website;
    //                 }
    //                 if(!website) {
    //                     website = 'https://www.canarchy.beer';
    //                 }
    //             });
    //         }
    //         if(website) {
    //             result.beer.href = website;
    //         } else {
    //             result.beer.href = 'https://www.oskarblues.com/';
    //         }

    //     });
    //     // get the links here
    //     displayResults(beers);
    //     $('#beerDiscoveryLoader').hide();
    // }

    function getBreweries(results) {
        $.ajax({
            type: 'POST',
            dataType: "json",
            url: '/wp-admin/admin-ajax.php',
            data: {
                "action": "get_breweries"
            },
            success: function(response) {
                var data = $.parseJSON(response);
                getLinks(results, data);
            },
            error: function(err) {
                console.error(err);
            }
        });
    }

    function discoverBeer (data) {

        var prefs = {};

        // abv is a range
        prefs.abv = [
            parseInt($('#bottom-range').val()),
            parseInt($('#top-range').val())
        ];
        prefs.srm = getRangeValues('.srm-picker input[type="checkbox"]:checked');
        prefs.flavors = getCheckboxValues('.discovery-flavors input[type="checkbox"]:checked');
        prefs.hoppy = $('.hoppy input[type="radio"]:checked').val() === 'hops';

        var scores = data.beers.map(function (beer) {
            return getBeerScore(prefs, beer);
        });

        var results = [];
        var i;
        for (i = 0; i < data.beers.length; i++) {
            var result = {};
            result.beer = data.beers[i];
            result.score = scores[i];
            results.push(result);
        }
        results.sort(compare);
        //console.log({results})


        var abvForGA = prefs.abv[0]+'-'+prefs.abv[1];
        var srmForGA = '';

        //console.log(prefs.srm);
        for(var x=0; x < prefs.srm.length; x++){
            var srmI = prefs.srm[x];
            if(isNaN(srmI[0])){
                srmForGA += 'pink ';
            }else{
                srmForGA += srmI[0]+'-'+srmI[1]+' ';
            }
        }

        var flavorsForGA = '';
        for(var q=0; q < prefs.flavors.length; q++){
            var flavorsI = prefs.flavors[q];

            flavorsForGA += slugify(flavorsI)+' ';
        }

        var hoppyForGA = (prefs.hoppy)? 'Yes' : 'No';

        window.dataLayer.push({
            'event':'completedBeerDiscoveryStep',
            'eventCategory': 'Beer Discovery',
            'eventAction': 'Completed Step',
            'eventLabel': 'Completed'
        });

        window.dataLayer.push({
            'event':'completedBeerDiscoverySearch',
            'eventCategory': 'Beer Discovery',
            'eventAction':'Submit',
            'dimension7':prefs.abv[0],
            'dimension11':prefs.abv[1],
            'dimension8':srmForGA,
            'dimension9':hoppyForGA,
            'dimension10':flavorsForGA,
            'dimension14':results[0].beer.name
        });

        for(var x=0; x < prefs.flavors.length; x++){
            var flavorI = prefs.flavors[x];

            for(var q=0; q < prefs.srm.length; q++){
                var srmI = prefs.srm[q];
                
                if(isNaN(srmI[0])){
                    srmForGA = 'pink';
                }else{
                    srmForGA = srmI[0]+'-'+srmI[1];
                }

                window.dataLayer.push({
                    'event':'BeerDiscoverySearchCombinations',
                    'eventCategory': 'Beer Discovery',
                    'eventAction': 'Selected Options',
                    'dimension7':prefs.abv[0],
                    'dimension11':prefs.abv[1],
                    'dimension8':srmForGA,
                    'dimension9':hoppyForGA,
                    'dimension10':flavorI,
                    'dimension14':results[0].beer.name
                });

            }
        }

        return results;

    }

    function getCheckboxValues (sel) {
        return $(sel).map(function (idx, ele) { return $(ele).val(); }).get();
    }
    function getRangeValues (sel) {
        var mins = $(sel).map(function (idx, ele) { return $(ele).attr('data-min'); }).get();
        var maxes = $(sel).map(function (idx, ele) { return $(ele).attr('data-max'); }).get();
        var ranges = [];
        var i;
        for (i = 0; i < mins.length; i++) {
            var range = [parseInt(mins[i]), parseInt(maxes[i])]
            ranges.push(range);
        }
        return ranges;

    }
    function getBeerScore (prefs, beer) {
        var breweryID = beer.brewery.id;

        if (breweryID === '5c48e2ed3596af000417e100' || breweryID === '5cca092ca4d31151965e77fb') { //OB or perrin

            var score = 0;

            // abv subscore
            if (beer.abv >= prefs.abv[0]) {
                score++;
            }
            if (beer.abv <= prefs.abv[1]) {
                score++;
            }

            // hops subscore
            if (beer.ibu >= 40 && prefs.hoppy || beer.ibu < 40 && !prefs.hoppy) {
                score+=2;
            }

            // srm subscore
            var srm = prefs.srm.some(function(srm) {
                return srm[0] <= beer.srm && beer.srm <= srm[1];
            });
            // srm exception for Guns N Rose
            if(isNaN(prefs.srm[0]) && beer.name == "Rosé for Daze") {
                srm = true;
            }
            if(srm) {
                score+=2;
            }
            // flavor subscore
            if (beer.flavors) {
                beer.flavors.forEach(function (flavor) {
                    if (flavor.name) {
                        var name = flavor.name.toLowerCase();
                        if(prefs.flavors.includes(name)) {
                            score++;
                        }
                    }

                });
            }
            return score;
        }
    }

    function compare(a,b) {
        if (a.score > b.score)
            return -1;
        if (a.score < b.score)
            return 1;
        return 0;
    }

    function eventSubMenu() {
        if ($(window).width() < 1025) {
            $('.event-section-links').slick({
                infinite: false,
                dots: false,
                arrows: false,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: {
                            settings: 'unslick'
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                        }
                    }
                ]
            });
            $('.event-section-links').show();
        }
    }

    function slugify(string) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')
        
        return string.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w\-]+/g, '') // Remove all non-word characters
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '') // Trim - from end of text
    }
})(jQuery);
